module.exports = __webpack_public_path__ + "static/tabaxi_minstrel-2e58ebd931b848f9ef8f177c5bd3605b.png";